import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const RootStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  border: '1px solid #CACACA',
  borderRadius: '8px',
  padding: '12px 16px',
  marginBottom: '15px',
  width: '40%',
});

export const ImgItemContainer = styled(Box)({
  backgroundColor: '#E6E6E6',
  padding: '12px',
  borderRadius: '6px',
});

export const FileName = styled(Typography)({
  fontSize: '1rem',
  fontWeight: 'bold',
  color: '#1A1A1A',
});

export const FileSize = styled(Typography)({
  fontSize: '1rem',
  color: '#525252',
});
